import { useTenantContext } from '../tenant-context/index.tsx';

export const useIsSiteAdmin = (): boolean => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.isSiteAdmin) || false;
};
